module.exports = __webpack_public_path__ + "static/home-willbud-puck-f1271dc7f3c4bdb0526deab648564719.jpg";